var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.809,
    height: 122.674,
    viewBox: "0 0 142.809 122.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-library-1230995",
    transform: "translate(-3.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294",
    "data-name": "Caminho 294",
    d: "M211.519,181.232a9.3,9.3,0,0,0,9.3-9.3V161.282h3.689a9.3,9.3,0,1,0,0-18.6H203.521l11.966-2.4a1.552,1.552,0,0,0,1.21-1.768l-14.23-71.1a1.548,1.548,0,0,0-1.828-1.209l-24.305,4.851a1.549,1.549,0,0,0-1.24,1.829l.868,4.355a1.391,1.391,0,0,0-.232,0H152.477V60.186a1.55,1.55,0,0,0-1.55-1.549h-49.6a1.55,1.55,0,0,0-1.551,1.549v82.558a9.316,9.316,0,0,0,1.086,18.6h3.7v10.664a9.3,9.3,0,1,0,18.6,0V161.283h79.054v10.664a9.3,9.3,0,0,0,9.3,9.285Zm6.2-9.3h0a6.2,6.2,0,0,1-12.4,0V161.282h12.4Zm-17.98-102.4,13.625,68.018-21.221,4.263L178.457,73.8Zm-10.7,73.15h-11.78v-58.9Zm-14.881-62.39v62.39h-21.7V80.294Zm-24.8-18.6v80.991h-21.7V61.693Zm-24.8,0v80.991h-21.7V61.693ZM94.675,151.985a6.2,6.2,0,0,1,6.2-6.2H224.493a6.2,6.2,0,0,1,0,12.4H100.875a6.2,6.2,0,0,1-6.2-6.2Zm25.39,19.95a6.2,6.2,0,0,1-12.4,0V161.285h12.4Z",
    transform: "translate(-87.13 -58.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    "data-name": "Caminho 295",
    d: "M247.24,113.06h8.6v3.1h-8.6Z",
    transform: "translate(-200.123 -97.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    "data-name": "Caminho 296",
    d: "M157.64,113.06h8.6v3.1h-8.6Z",
    transform: "translate(-135.324 -97.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    "data-name": "Caminho 297",
    d: "M336.84,180.27h8.6v3.1h-8.6Z",
    transform: "translate(-264.921 -146.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    "data-name": "Caminho 298",
    d: "M247.24,292.27h8.6v3.1h-8.6Z",
    transform: "translate(-200.123 -227.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    "data-name": "Caminho 299",
    d: "M157.64,292.27h8.6v3.1h-8.6Z",
    transform: "translate(-135.324 -227.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    "data-name": "Caminho 300",
    d: "M336.84,292.27h8.6v3.1h-8.6Z",
    transform: "translate(-264.921 -227.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_301",
    "data-name": "Caminho 301",
    d: "M438.7,146.927l8.436-1.689.609,3.039-8.436,1.689Z",
    transform: "translate(-338.587 -121.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    "data-name": "Caminho 302",
    d: "M467.23,289.687,475.666,288l.609,3.039-8.436,1.689Z",
    transform: "translate(-359.22 -224.511)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.269e3aa7c9fbeceb32fd420263bf086b.svg";
export { ForwardRef as ReactComponent };